import navbarSearch from '../modules/navbar-search';
import {initializeAdmin} from '../modules/admin/hamburger';
import socialAnalytics from '../utils/social_analytics_util';
let commonController = () => {
    // require('../modules/adblock').on();
    require('../modules/hamburger').on();
    require('../modules/hamburger-sections')();
    require('../modules/randomize-ab-nav')();
    navbarSearch.on();
    initializeAdmin();
    socialAnalytics();
};

export default commonController;
